import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { PUBLIC_USER } from 'marketplace-ui-reviews/constants/UnreviewableReason';
import { Button } from 'foundations-components/transitional/components/Button';
import { getIsPublicApp } from '../../selectors/app';
import { jsx as _jsx } from "react/jsx-runtime";
export default function WriteReviewButton({
  disabled = false,
  hasEditableReview,
  onClick,
  size = 'sm',
  unreviewableReason,
  reviewPending
}) {
  const isPublicApp = useSelector(getIsPublicApp);
  const isReviewable = isPublicApp || !unreviewableReason || unreviewableReason !== 'ReviewError.EDIT_PENDING' && hasEditableReview;
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: reviewPending ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.themes.details.reviews.unreviewable.reviewSubmitted"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-ui-reviews.error.${isPublicApp ? `ReviewError.${PUBLIC_USER}` : unreviewableReason}`
      }),
      disabled: reviewPending ? false : isReviewable,
      placement: "left",
      children: /*#__PURE__*/_jsx(Button, {
        onClick: onClick,
        use: hasEditableReview ? 'tertiary-light' : 'tertiary',
        size: size,
        disabled: reviewPending || disabled || !isReviewable,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `marketplace-assets-ui.themes.details.reviews.write.${hasEditableReview ? 'edit' : 'button'}`
        })
      })
    })
  });
}